import SearchBar from '@/components/company/filters/SearchBar';
import FilterSelect from '@/components/company/filters/FilterSelect';
import ClearFilterButton from '@/components/company/filters/ClearFilterButton';
import { IJobDescription } from '@/states/job.state';
import { useMemo } from 'react';

interface Props {
  jobDescriptions: IJobDescription[];
  searchTerm: string;
  selectedRole: string;
  selectedActivity: string;
  onSearch: (v: string) => void;
  onRoleChange: (v: string) => void;
  onActivityChange: (v: string) => void;
  onClear: () => void;
  showRoleFilter?: boolean;
}

export default function ReportFilters({
  jobDescriptions,
  searchTerm,
  selectedRole,
  selectedActivity,
  onSearch,
  onRoleChange,
  onActivityChange,
  onClear,
  showRoleFilter = true,
}: Props) {
  const roleOptions = useMemo(
    () =>
      Array.from(
        new Map(jobDescriptions.map(jd => [jd.org_chart_node_id, jd.org_chart_node?.name ?? '-'])).entries(),
      ).map(([id, name]) => ({ label: name.split(',')[0]?.trim() ?? name, value: String(id) })),
    [jobDescriptions],
  );

  const activityOptions = useMemo(
    () =>
      Array.from(
        new Map(jobDescriptions.map(jd => [jd.org_key_activity_id, jd.org_key_activity?.name ?? '-'])).entries(),
      ).map(([id, name]) => ({ label: name, value: String(id) })),
    [jobDescriptions],
  );

  return (
    <div className="flex flex-col md:flex-row justify-start mt-5 px-5 gap-2 w-full">
      <SearchBar value={searchTerm} onChange={onSearch} placeholder="Cari uraian tugas..." className="w-full md:w-72" />
      {showRoleFilter && (
        <FilterSelect label="Jabatan" options={roleOptions} value={selectedRole} onChange={onRoleChange} />
      )}
      <FilterSelect
        label="Key Activities"
        options={activityOptions}
        value={selectedActivity}
        onChange={onActivityChange}
      />
      <ClearFilterButton onClear={onClear} />
    </div>
  );
}
